module.exports = __webpack_public_path__ + "img/main.a7566a9b.jpg";